module.exports = __webpack_public_path__ + "01dc66890576f2e486790eb95d0fabbc.png";


//////////////////
// WEBPACK FOOTER
// ./js/img/ETHzurich.png
// module id = 1336
// module chunks = 0